// Sizes are in inches, landscape orientation (long side = width),
// matching how paper is always used in this app.
export const A4 = { width: 11.69, height: 8.27, name: "A4" };
export const LETTER = { width: 11, height: 8.5, name: "Letter" };

export const DEFAULT_PAPER = A4;

export const SUPPORTED_PAPERS = {
    'A4': A4,
    'Letter': LETTER
};

// Printers can't paint to the physical paper edge, so reserve a uniform margin
// (inches) that nothing is packed or drawn into.
export const PAGE_MARGIN = 0.4;

export function getPaperSize(paper, sheet) {
    if (paper) return paper;
    if (sheet && sheet.papersize) return sheet.papersize;
    return DEFAULT_PAPER;
}

// The rectangle we actually pack minis into *and* render — the paper minus the
// printer margin. Packing (PackedSheetView) and drawing (SheetCanvas) must both
// derive their bounds from this, or minis packed near an edge land in space the
// canvas then clips (MINI-28).
export function getPrintableArea(paper) {
    const p = paper || DEFAULT_PAPER;
    return { ...p, width: p.width - PAGE_MARGIN, height: p.height - PAGE_MARGIN };
}
